import { Box, CircularProgress } from '@mui/material';

export default function AppRouteLoader() {
    return (
        <Box
            sx={{
                alignItems: 'center',
                bgcolor: '#EFF3F7',
                display: 'flex',
                justifyContent: 'center',
                minHeight: '100dvh',
                width: '100%',
            }}
        >
            <Box
                sx={{
                    alignItems: 'center',
                    bgcolor: 'var(--lm-surface)',
                    border: '1px solid var(--lm-border)',
                    borderRadius: '16px',
                    display: 'flex',
                    height: 72,
                    justifyContent: 'center',
                    width: 72,
                }}
            >
                <CircularProgress size={28} />
            </Box>
        </Box>
    );
}
